<template>
  <div class="app" id="app" :class="[{ 'app_loading': loadingGui, 'app_error': errorGui}, `app-theme-${themeApp.getValue()}`]">
    <div class="app__wrapper">
      <div class="app__main">
        <router-view/>
      </div>
      <div class="app__footer">
        <div class="footer block">
          <div class="footer__wrapper block-wrapper">
            <div class="footer__main">
              {{ buildDate }} | {{ buildVersion }}
              <div v-if="id" class="footer__key">
                <div class="footer__key-icon">
                  <IconKey/>
                </div>
              </div>
              <div v-else class="footer__key">
                <div class="footer__key-icon">
                  <IconNotKey/>
                </div>
              </div>
            </div>
            <div class="footer__side">
              <div class="footer__copyright">
                <!--                {{ $t('common.copyright') }}-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalLoader v-if="loadingGui"/>
      <ModalError v-if="errorGui"/>
      <ModalWarning v-if="warningGui"/>
    </div>
  </div>
</template>

<script>
import ModalLoader from '@/components/modals/ModalLoader'
import ModalError from '@/components/modals/ModalError'
import ModalWarning from '@/components/modals/ModalWarning'
import loadingGuiManager from '@/mixins/gui/loading-gui-manager'
import IconNotKey from '@/components/icons/IconNotKey'
import IconKey from '@/components/icons/IconKey'
import {mapState} from 'vuex'
import ThemeTypes from '@/utils/theme-types'

import '@fortawesome/fontawesome-free/css/all.css'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'

export default {
  mixins: [
    loadingGuiManager
  ],
  components: {
    ModalError,
    ModalWarning,
    ModalLoader,
    IconNotKey,
    IconKey
  },
  computed: {
    ...mapState({
      id: state => state.app.id
    })
  },
  data() {
    return {
      buildDate: process.env.VUE_APP_BUILD,
      buildVersion: process.env.VUE_APP_VERSION,
      themeApp: ThemeTypes.SMARTIX
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search).get('theme')
    this.themeApp = ThemeTypes.isValidValue(urlParams) ? ThemeTypes.fromValue(urlParams) : ThemeTypes.SMARTIX
  }
}
</script>

<style lang="stylus">
@import "./assets/style/common.styl"
</style>
